"use client";

import _slicedToArray from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useDialogStoreProps } from "./BM6PGYQY.js";
import { useStore, useStoreProps } from "./YV4JVR4I.js";
import { useUpdateEffect } from "./ABQUS43J.js"; // src/popover/popover-store.ts

import * as Core from "@ariakit/core/popover/popover-store";

function usePopoverStoreProps(store, update, props) {
  useUpdateEffect(update, [props.popover]);
  useStoreProps(store, props, "placement");
  return useDialogStoreProps(store, update, props);
}

function usePopoverStore() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _useStore = useStore(Core.createPopoverStore, props),
      _useStore2 = _slicedToArray(_useStore, 2),
      store = _useStore2[0],
      update = _useStore2[1];

  return usePopoverStoreProps(store, update, props);
}

export { usePopoverStoreProps, usePopoverStore };